import { atomWithQuery } from 'jotai-tanstack-query';
import { codeAtom } from './code';
import { kreedaService } from '../../services/kreeda.service';
const kreedaAtom = atomWithQuery((get) => {
    const code = get(codeAtom);
    return {
        queryKey: ['kreeda', code],
        queryFn: async () => {
            return await kreedaService.getKreedaDetails(code);
        },
        retry: 0,
        enabled: !!code,
    };
});
export { kreedaAtom };
